  <template>
  <div ref="noticeToolModalRef">
  <artmisads-modal
      v-model:open="open"
      title="Download Invoice Association Reports"
      :width="1200"
      :getContainer="() => $refs.noticeToolModalRef"
      :destroyOnClose="true"
      :maskClosable="false"
      :footer="null"
      :onCancel="onCancel"
    >
     <artmisads-table
      :columns="columns"
      :loading="spinning"
      :data-source="dataList"
      :pagination="{
            total: pagination.total,
            pageSize: pagination.pageSize,
            current: pagination.page,
             pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true
          }" :change="onChangePage"
      rowClassName="table-item"
    >  
    <template #bodyCell="{ column, record, text }">
        <template v-if="column.name === 'billingDateTimestamp'">
          {{ moment(record.billingDateTimestamp).tz(BILLING_TIME_TZ[record.marketplace]).format('YYYY-MM') }}
        </template>
        <template v-if="column.name === 'transactionCycleStartDate'">
          {{ record.transactionCycleStartDate }} - {{ record.transactionCycleEndDate }}
        </template>
         <template v-if="column.name === 'amount'&&record.billingType !== 'MONTHLY'">
            <div :class="text? text > 0 ? 'amount-plus' : 'amount-minus':''">
              {{ setUnit(text) }} {{text||text==0? AMAZON_CURRENCY_MAPPER[record.marketplace] :''}}{{ setAmount(text) }}
            </div>
         </template>
          <template v-if="column.name === 'amount'&&record.billingType === 'MONTHLY'">
          {{text||text==0? AMAZON_CURRENCY_MAPPER[record.marketplace] :'--'}}{{ text }}
         </template>
           <template v-if="column.name === 'action'">
        <artmisads-select-button @click="() =>download(record)"
              size="small">Download</artmisads-select-button>
       </template>
       </template>
     
    </artmisads-table>
    <div class="bottom">
      <div class="bottoml-left">
        <Icon name="wenhao-tianchong" class="bottoml-left-icon"/>
      </div>
      <div class="bottom-right">
        <div class="bottom-right-title">
         Why is there a discrepancy between performance and invoice data?
        </div>
        <div class="bottom-right-content">
          Invoice amounts and related transaction data are locked at the moment the system generates the invoice and will not reflect any subsequent changes to sales data.
        </div>
        <div class="bottom-right-content">
          Performance data, however, is updated in real-time and includes all sales data changes up to the current date.
        </div>
      </div>
    </div>
    </artmisads-modal>
  </div>
   
</template>
<script setup>
import { ref ,defineExpose} from 'vue'
import { financeApi } from "~/server";
import moment from 'moment'
import { CURRENCY_MAPPER, AMAZON_CURRENCY_MAPPER,BILLING_TIME_TZ } from "@/contants/common";
import { useUserInfoStore } from "@/storeData";
import Icon from '@/components/Icon.vue'

const user = useUserInfoStore();
const spinning = ref(false)
const open = ref(false)
const pagination = ref({
  total: 0,
  pageSize: 10,
  page: 1,
})
const dataList = ref([])
const countryCode = user?.userInfo?.countryCode || 'US';
const columns=ref([
  {
    title: 'Billing Date',
    name: 'billingDateTimestamp',
    dataIndex: 'billingDateTimestamp',
  },
    {
   
    title:'Type',
    dataIndex: 'billingType',
    name: 'billingType',
  },
   {
    title: 'Transaction Cycle',
    dataIndex: 'transactionCycleStartDate',
   
    name: 'transactionCycleStartDate'
  },
    {
    title: 'Marketplace',
    dataIndex: 'marketplace',
    name: 'marketplace'
  },
    {
    title: 'Amount',
    dataIndex: 'amount',
    name: 'amount',
  },
    {
    title: 'Download Report',
    dataIndex: 'action',
    name: 'action',
  },
    
])
const setUnit = (record) => {
  if(record||record==0){
    if (record > 0) {
    return '+'
  }
  else if(record == 0){
    return ''
  }
  else {
    return '-'
  }
  }
  else{
    return ''
  }
}
const setAmount = (record) => {
  if(record||record==0){
  return Math.abs(record)
  }
  else{
    return '--'
  }
}
const download=(record)=>{
 
  financeApi.exportReport({
    qs: {
      billingId: record.billingId,
    },
    fileName: `report_${moment().format('YYYY-MM-DD')}.csv`,
  })
}
const onChangePage = ({current,pageSize}) => {
  pagination.value.page = current;
  pagination.value.pageSize = pageSize;
  getData();
}
const onCancel = () => {
  open.value = false
}
const openModal = () => {
  open.value = true
  getData()
}
const getData = async () => {
  spinning.value = true;
  const paramsData = {
    page: pagination.value.page,
    size: pagination.value.pageSize,
    marketplace: CURRENCY_MAPPER[countryCode].host,
  };
  paramsData.startBillingDateStr = `${moment(moment().subtract(365, "day").valueOf()).format('YYYY-MM')}-01`;
  paramsData.endBillingDateStr = moment().endOf('month').format('YYYY-MM-DD');

  const res = await financeApi.getFinanceSellerBillingsList(paramsData);
  const { data, success } = res;
  if (success) {
    pagination.value.total = data.total;
    dataList.value = data.data;
  }
  spinning.value = false;
};
defineExpose({
  openModal,
 })
</script>
<style scoped lang="less">
.bottom{
  border-top: 1px solid rgba(232, 229, 237, 1);
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
  gap: 8px;
  .bottoml-left{
    margin-top: 3px;
  }
  .bottom-right{
    .bottom-right-title{
      font-size: 14px;
      font-weight: 700;
      line-height: 24px;
      color: rgba(33, 30, 42, 1);
    }
  }
}
.amount-plus{
  color: #009900;
}
.amount-minus{
  color: #FF0000;
}
</style>